// 物料相关字段

import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

const materialTypeList = [
  { label: '电商供应商物料', value: '2' },
  { label: '供应商物料', value: '1' },
] as const

export type MaterialTypeValue = ValueOf<typeof materialTypeList>
export const materialTypeEnum = customCreateEnum(materialTypeList)

const productStatusList = [
  { value: '0', label: '删除' },
  { value: '1', label: '正常' },
  { value: '5', label: '新增审核中' },
  { value: '11', label: '修改审核中' },
  { value: '22', label: '驳回' },
  { value: '9', label: '撤回' },
  { value: '10', label: '暂存' },
  { value: '23', label: '放弃（自动执行）' },
] as const

export const productStatusEnum = customCreateEnum(productStatusList)

// 图片资质类型(项目型字段)
export const qualityTypeList = [
  { value: '1', label: '质量标准凭证' },
  { value: '2', label: '国际编码凭证' },
  { value: '3', label: '涨价函' },
  { value: '4', label: '下架说明' },
  { value: '5', label: '国网商品截图' },
  { value: '6', label: '易派客商品截图' },
  { value: '7', label: '报价单' },
  { value: '8', label: '商品资质' },
  { value: '11', label: '3C认证' },
  { value: '12', label: 'LA' },
  { value: '13', label: '检测报告' },
  { value: '14', label: '防爆合格证' },
  { value: '15', label: '合格证' },
  { value: '16', label: '其他 (生产许可证等)' },
  { value: '18', label: '品牌授权信息' },
]
export const qualityTypeEnum = customCreateEnum(qualityTypeList)

export const reportTypeList = [
  { value: 'NEW', label: '商品新增' },
  { value: 'MODIFY', label: '商品修改' },
  { value: 'SHELF_MODIFY', label: '商品上下架更新' },
  { value: 'PRICE_MODIFY', label: '商品价格更新' },
  { value: 'RELAUNCHED', label: '商品重推' },
]
export const reportTypeEnum = customCreateEnum(reportTypeList)
export type reportTypeEnumValue = ValueOf<typeof reportTypeEnum>

export const shelfStatusList = [
  { value: '1', label: '上架' },
  { value: '2', label: '下架' },
]
export const shelfStatusEnum = customCreateEnum(shelfStatusList)

export const attributeTypeList = [
  { value: 'SINGLE_ENUMS', label: '单选' },
  { value: 'MULTI_ENUMS', label: '多选' },
  { value: 'TEXT', label: '文本' },
  { value: 'DIGITS', label: '数值' },
]
export const attributeTypeEnum = customCreateEnum(attributeTypeList)

export const preReviewOfMaterialsTypeList = [
  { value: 'ADD_PRODUCT', label: '新增物料' },
  { value: 'MATERIAL_REPORT_UPDATE', label: '单条提报' },
  { value: 'MATERIAL_REPORT_SAVE_NEW', label: '提报驳回更新' },
]
export const preReviewOfMaterialsTypeEnum = customCreateEnum(
  preReviewOfMaterialsTypeList,
)
export type preReviewOfMaterialsTypeEnumValue = ValueOf<
  typeof preReviewOfMaterialsTypeEnum
>
// 物料相关字段

import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

const materialTypeList = [
  { label: '电商供应商物料', value: '2' },
  { label: '供应商物料', value: '1' },
] as const

export type MaterialTypeValue = ValueOf<typeof materialTypeList>
export const materialTypeEnum = customCreateEnum(materialTypeList)

const productStatusList = [
  { value: '0', label: '删除' },
  { value: '1', label: '正常' },
  { value: '5', label: '新增审核中' },
  { value: '11', label: '修改审核中' },
  { value: '22', label: '驳回' },
  { value: '9', label: '撤回' },
  { value: '10', label: '暂存' },
  { value: '23', label: '放弃（自动执行）' },
] as const

export const productStatusEnum = customCreateEnum(productStatusList)

// 图片资质类型(项目型字段)
export const qualityTypeList = [
  { value: '1', label: '质量标准凭证' },
  { value: '2', label: '国际编码凭证' },
  { value: '3', label: '涨价函' },
  { value: '4', label: '下架说明' },
  { value: '5', label: '国网商品截图' },
  { value: '6', label: '易派客商品截图' },
  { value: '7', label: '报价单' },
  { value: '8', label: '商品资质' },
  { value: '11', label: '3C认证' },
  { value: '12', label: 'LA' },
  { value: '13', label: '检测报告' },
  { value: '14', label: '防爆合格证' },
  { value: '15', label: '合格证' },
  { value: '16', label: '其他 (生产许可证等)' },
  { value: '18', label: '品牌授权信息' },
]
export const qualityTypeEnum = customCreateEnum(qualityTypeList)

export const reportTypeList = [
  { value: 'NEW', label: '商品新增' },
  { value: 'MODIFY', label: '商品修改' },
  { value: 'SHELF_MODIFY', label: '商品上下架更新' },
  { value: 'PRICE_MODIFY', label: '商品价格更新' },
  { value: 'RELAUNCHED', label: '商品重推' },
]
export const reportTypeEnum = customCreateEnum(reportTypeList)
export type reportTypeEnumValue = ValueOf<typeof reportTypeEnum>

export const shelfStatusList = [
  { value: '1', label: '上架' },
  { value: '2', label: '下架' },
]
export const shelfStatusEnum = customCreateEnum(shelfStatusList)

export const attributeTypeList = [
  { value: 'SINGLE_ENUMS', label: '单选' },
  { value: 'MULTI_ENUMS', label: '多选' },
  { value: 'TEXT', label: '文本' },
  { value: 'DIGITS', label: '数值' },
]
export const attributeTypeEnum = customCreateEnum(attributeTypeList)

export const preReviewOfMaterialsTypeList = [
  { value: 'ADD_PRODUCT', label: '新增物料' },
  { value: 'MATERIAL_REPORT_UPDATE', label: '单条提报' },
  { value: 'MATERIAL_REPORT_SAVE_NEW', label: '提报驳回更新' },
]
export const preReviewOfMaterialsTypeEnum = customCreateEnum(
  preReviewOfMaterialsTypeList,
)
export type preReviewOfMaterialsTypeEnumValue = ValueOf<
  typeof preReviewOfMaterialsTypeEnum
>
